import { useFetchPostV2 } from "hooks/fetch/useFetchPostV2";
import { ChartData, SavedChart } from "interfaces/chart";

export interface PostChartBody {
  chart_name: string;
  chart_object: ChartData;
}

/** Provides a callback which can be used to save a chart in the API */
export const usePostChart = (): {
  loading: boolean;
  error: boolean;
  postChartCallback: (body: PostChartBody) => Promise<SavedChart>;
} => {
  const { loading, error, postCallback } = useFetchPostV2("charts");

  return { loading, error, postChartCallback: postCallback };
};
